/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Timecode_Format_MsInputs */



/**
* | output |
* | --- |
* | "Millisecond TC (hh:mm:ss.mmm)" |
*
* @param {Transcript_Export_Timecode_Format_MsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_timecode_format_ms = /** @type {((inputs?: Transcript_Export_Timecode_Format_MsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Timecode_Format_MsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Timecode millisecondes (hh:mm:ss.mmm)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Millisekunden-TC (hh:mm:ss.mmm)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Millisecondo TC (hh:mm:ss.mmm)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Миллисекундный TC (чч:мм:сс.ммм)")
	if (locale === "es") return /** @type {LocalizedString} */ ("TC de milisegundos (hh:mm:ss.mmm)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("毫秒 TC（hh:mm:ss.mmm）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ミリ秒 TC (hh:mm:ss.mmm)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मिलीसेकंड टीसी (hh:mm:ss.mmm)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("TC em milissegundos (hh:mm:ss.mmm)")
	return /** @type {LocalizedString} */ ("Millisecond TC (hh:mm:ss.mmm)")
});